import React from "react";
import { Box, Typography, Collapse, SvgIcon } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { colors } from "../../../config";

interface CollapsibleSectionProps {
  title: string;
  value: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

export default function CollapsibleSection({
  title,
  value,
  isOpen,
  onToggle,
  children,
}: CollapsibleSectionProps) {
  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ 
          cursor: "pointer",
          py: 0.375,
          minHeight: "26px",
          "&:hover": {
            backgroundColor: colors.primary.background,
          },
        }}
        onClick={onToggle}
      >
        <Typography fontSize="12px" fontWeight={500} color={colors.text.primary} lineHeight="20px">
          {title}
        </Typography>
        <Box display="flex" alignItems="center" gap={0.5}>
          <Typography fontSize="12px" fontWeight={500} color={colors.text.primary} lineHeight="20px">
            {value}
          </Typography>
          <SvgIcon
            component={KeyboardArrowDownIcon}
            sx={{
              fontSize: "16px",
              color: colors.primary.dark,
              transition: "transform 0.25s ease",
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </Box>
      </Box>
      <Collapse
        in={isOpen}
        sx={{
          "& .MuiCollapse-wrapperInner": {
            pt: 0.25,
            pb: 0.5,
          },
        }}
      >
        {children}
      </Collapse>
    </>
  );
}

